module.exports = __webpack_public_path__ + "static/img/2.1a86d91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/5/2.png
// module id = A4y2
// module chunks = 0